import CONFIG from '@/common/config.js'
import {
	$outLogin,
	$clearAppStore
} from '@/common/utils/tool.js'
const {
	$DOMAIN
} = CONFIG
const SUCCESS_CODE_LIST = {
	0: true,
}
const OUTLOGIN_CODE_LIST = {
	201: '请登录',
	1001: '用户不存在',
	1008: '用户已禁用',
	1009: '用户已删除或状态被禁用',
}
const install = (Vue) => {
	// 初始化请求配置
	Vue.config.globalProperties.$u.http.setConfig((config) => {
		/* config 为默认全局配置*/
		config.baseURL = $DOMAIN
		return config
	})
	// 请求拦截
	Vue.config.globalProperties.$u.http.interceptors.request.use((config) => { // 可使用async await 做异步操作
		return handleParams(config)
	}, config => { // 可使用async await 做异步操作
		return Promise.reject(config)
	})
	// 响应拦截
	Vue.config.globalProperties.$u.http.interceptors.response.use((response) => {
		/* 对响应成功做点什么 可使用async await 做异步操作*/
		const data = response.data
		// 自定义参数
		const custom = response.config?.custom
		custom.showmask && uni.hideLoading()

		if (SUCCESS_CODE_LIST[data.code]) {
			return Promise.resolve(data)
		} else {
			if (OUTLOGIN_CODE_LIST[data.code]) { //TOKEN过期
				$clearAppStore()
				return uni.$u.route({
					url: '/view/login'
				})
			}
			//closeErrorTips 关闭错误提示
			if (!custom.closeErrorTips) uni.$u.toast(data.message)
			return Promise.reject(data)
		}

	}, (response) => {

		uni.hideLoading()
		return Promise.reject(response)
	})
}
async function handleParams(config) {
	let timestamp = Date.now()
	config.header.Authorization = uni.$store('data').getUserInfo?.token
	config.custom.showmask && uni.showLoading({
		title: '加载中...',
		mask: true
	})
	return config
}
export default {
	install
}